export class ReportListItemData {
  private static numKeys = [
    'userID',
    'clubID',
    'clubProgramID',
    'clubProgramTypeID',
    'regStatus',
    'programStatus'
  ];
  private static strKeys = [
    'avatar',
    'firstName',
    'lastName',
    'middleName',
    'gender',
    'email',
    'programName',
    'teamGroup'
  ];

  userID: number;
  avatar: string;
  firstName: string;
  lastName: string;
  middleName: string;
  gender: string;
  dob: Date;
  email: string;
  programName: string;
  clubID: number;
  clubProgramID: number;
  clubProgramTypeID: number;
  regStatus: number;
  programStatus: number;
  teamGroup: string;

  constructor(data: any = {}) {
    Object.keys(data).forEach(k => (this[k] = data[k]));

    ReportListItemData.numKeys.forEach(k => (this[k] = +data[k]));
    ReportListItemData.strKeys.forEach(k => (this[k] = data[k]));
    this.dob = new Date(data.dob);
  }

  get name() {
    return (
      `${this.lastName}, ${this.firstName}` +
      (this.middleName ? ` ${this.middleName}` : '')
    );
  }
}

export class ScholarshipReportListItemData {
  private static numKeys = [
    'clubUserProgramFeeID',
    'userID',
    'amount'
  ];
  private static strKeys = [
    'avatar',
    'firstName',
    'middleName',
    'lastName',
    'gender',
    'feeName',
    'scholarshipBy',
    'scholarshipType'
  ];

  clubUserProgramFeeID: number;
  userID: number;
  avatar: string;
  firstName: string;
  middleName: string;
  lastName: string;
  gender: string;
  dateAdded: Date;
  feeName: string;
  scholarshipBy: string;
  scholarshipType: string;
  amount: number;

  constructor(data: any = {}) {
    Object.keys(data).forEach(k => (this[k] = data[k]));

    ScholarshipReportListItemData.numKeys.forEach(k => (this[k] = +data[k]));
    ScholarshipReportListItemData.strKeys.forEach(k => (this[k] = data[k]));
    this.dateAdded = new Date(data.dateAdded);
  }

  get name() {
    return (
      `${this.lastName}, ${this.firstName}` +
      (this.middleName ? ` ${this.middleName}` : '')
    );
  }
}

export class DisputeReportListItemData {
  clubUserProgramFeeID: number;
  userID: number;
  paymentID: number;
  paymentAmount: number;
  disputedAmount: number;
  clubProgramID: number;

  firstName: string;
  lastName: string;
  avatar: string;
  feeName: string;
  status: string;
  reason: string;
  disputedID: string;

  paymentDate: Date;
  disputedDate: Date;
  respondByDate: Date;

  private static numKeys = [
    'clubUserProgramFeeID',
    'userID',
    'paymentID',
    'paymentAmount',
    'disputedAmount',
    'clubProgramID'
  ];

  private static strKeys = [
    'firstName',
    'lastName',
    'avatar',
    'feeName',
    'status',
    'reason',
    'disputedID'
  ];

  constructor(data: any = {}) {
    Object.keys(data).forEach(k => (this[k] = data[k]));

    DisputeReportListItemData.numKeys.forEach(k => (this[k] = +data[k]));
    DisputeReportListItemData.strKeys.forEach(k => (this[k] = data[k]));
    this.paymentDate = new Date(data.paymentDate);
    this.disputedDate = new Date(data.disputedDate);
    this.respondByDate = new Date(data.respondByDate);
  }

  get name() {
    return `${this.lastName}, ${this.firstName}`;
    // (this.middleName ? ` ${this.middleName}` : "")
  }
}



// WEBPACK FOOTER //
// ./src/app/models/reports/report-base.ts